const Page404 = () => {
  return (
    <div>
      <h1>Page non trouvée</h1>
    </div>
  );
};

export default Page404;
